export interface Agency {
  id: string;
  name: string;
  email?: string;
  phone?: string;
}

export enum DocumentSigningMode {
  BUYER_DOC_SIGNING = "BUYER_DOC_SIGNING",
  SELLER_DOC_SIGNING = "SELLER_DOC_SIGNING"
}

export enum PropertyTransferScreens {
  LOADING = "LOADING",
  SELECT_UNIT = "SELECT_UNIT",
  LEGALLY_FLAGGED = "LEGALLY_FLAGGED",
  BEGIN_JOURNEY = "BEGIN_JOURNEY",
  STATUS_SCREEN = "STATUS_SCREEN",
  SELLER_PROVIDE_BUYER_INFO = "SELLER_PROVIDE_BUYER_INFO",
  SELLER_ATTACH_UNIT_DOCUMENTS = "SELLER_ATTACH_UNIT_DOCUMENTS",
  SELLER_SUBMITTED = "SELLER_SUBMITTED",
  TRANSFER_TIMELINE = "TRANSFER_TIMELINE",
  BUYER_SPA = "BUYER_SPA",
  DOC_SIGN_STATUS = "DOC_SIGN_STATUS",
  BANKING_DETAILS = "BANKING_DETAILS",
  BUYER_SHARE_BANK_DETAILS = "BUYER_SHARE_BANK_DETAILS",
  DIRECT_DEBIT_LOCATIONS = "DIRECT_DEBIT_LOCATIONS",
  TRASNFER_PAYMENT = "TRASNFER_PAYMENT",
  TRASNFER_PAYMENT_STATUS = "TRASNFER_PAYMENT_STATUS",
  REQUEST_SUBMITTED = "REQUEST_SUBMITTED",
  SELLER_SIGN_TRANSFER_DOC = "SELLER_SIGN_TRANSFER_DOC",
  SELLER_TRASNFER_PAYMENT = "SELLER_TRASNFER_PAYMENT",
  SELLER_TRASNFER_PAYMENT_STATUS = "SELLER_TRASNFER_PAYMENT_STATUS",
  SELLER_REQUEST_SUBMITTED = "SELLER_REQUEST_SUBMITTED",
  SELLER_PDC_DD_CANCELLATION_FORM = "SELLER_PDC_DD_CANCELLATION_FORM",
  SELLER_PDC_DD_CANCELLATION_SUBMITTED = "SELLER_PDC_DD_CANCELLATION_SUBMITTED",
}

export enum TransferRequestStatuses {
  SELLER_INIT = 'seller_init',
  SELLER_SUBMITTED = 'seller_submitted',
  BUYER_IS_RESIDENT = 'is_buyer_resident',
  BUYER_DOCUMENT_VERIFIED = 'buyer_document_verified',
  BUYER_DOCUMENTS_SIGNED = 'buyer_documents_signed',
  BUYER_SPA_SIGNED = 'buyer_spa_signed',
  BUYER_TRANSFER_DOC_SIGNED = 'buyer_transfer_doc_signed',
  BUYER_DD_BANK_SUBMITTED = 'buyer_dd_bank_submitted',
  BUYER_LOCATION_SUBMITTED = 'buyer_location_submitted',
  BUYER_NO_LOCAL_BANK = 'buyer_no_local_bank',
  BUYER_TRANSFER_FEE_PAID = 'buyer_transfer_fee_paid',
  BUYER_FORM_SUBMITTED = 'buyer_form_submitted',
  SELLER_TRANSFER_DOC_SIGNED = 'seller_transfer_doc_signed',
  SELLER_TRANSFER_FEE_PAID = 'seller_transfer_fee_paid',
  SELLER_FINAL_SUBMISSION = 'seller_final_submission',
  SELLER_PDC_ENABLED = 'seller_pdc_dd_cancellation_enabled',
  SELLER_PDC_SUBMITTED = 'seller_pdc_dd_cancellation_submitted',
  SELLER_PDC_COMPLETED = 'seller_pdc_dd_cancellation_completed'
}

export enum TimelineSteps {
  PROVIDE_BUYER_INFO = "provideBuyerInfo",
  PROVIDE_DOCUMENTS = "provideDocuments",
  BUYER_ONBOARDING = "buyerOnboarding",
  PAY_FEES = "payFees",
  SIGN_TRANSFER_DOCUMENT = "signTransferDocument",
  TRANSFER_COMPLETE = "transferComplete",
  PDC_COLLECTION = "pdcCollection"
}

export enum TimelineSubSteps {
  PROVIDE_KYC = "provideKYC",
  DOCUMENT_VERIFICATION = "documentVerification",
  DIGITAL_SPA = "digitalSPA",
  SUBMIT_DIRECT_DEBIT = "submitDirectDebit",
  PAY_FEES = "payFees",
}

export enum NavigationActions {
  CLOSE = "CLOSE",
  BACK = "BACK"
}

export enum PropertyTransferEntryPoints {
  BUYER_CARD = "BUYER_CARD",
  SERVICE_REQUEST = "SERVICE_REQUEST"
}

export enum PropertyCity {
  ABH_DHABI = "Abu Dhabi",
  DUBAI = "Dubai"
}

export enum PayByType {
  BUYER = "BUYER",
  DEVELOPER = "DEVELOPER"
}

export enum OffplanRoles {
  BUYER = "BUYER",
  SELLER = "SELLER",
  ALL = "ALL"
}

export const PropertyTransferSRType = "Property Transfer (Off Plan)";

export enum timelineStepStatuses {
  COMPLETED = "completed",
  IN_PROGRESS = "inProgress",
  PENDING = "pending",
  FAILED = "failed"
}

export enum UploadStatus {
  IN_PROGRESS = "inProgress",
  UPLOADING = "uploading",
  COMPLETED = "completed",
  FAILED = "failed",
  PENDING = "pending"
}

export enum TransferDocuments {
  SPA = "PT Unified Digital SPA",
  TransferDoc = "Print Assignment of Rights"
}

export interface SRDocumentDetailsType {
  status: string;
  rejectedComments: string | null;
  name: string;
  id: string;
}

export interface BuyerInfoFormData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  buyerPaysFees: boolean;
  hasBroker: boolean;
}

export interface UpdateDocumentsFormData {
  hasBroker?: boolean;
  agencyName: string;
  agencyEmail: string;
  agencyPhone: string;
  sellingPrice: string;
  formF: File | null;
  hasMortgage: boolean;
  mortgageDocument: File | null;
  hasPowerOfAttorney: boolean;
  poaDocument: File | null;
  selectedAgency?: Agency | null;
}

export interface PropertyTransferFormData {
  // Buyer Info fields
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  buyerPaysFees?: boolean;
  hasBroker?: boolean;
  // Update Documents fields
  agencyName?: string;
  agencyEmail?: string;
  agencyPhone?: string;
  sellingPrice?: string;
  formF?: File | null;
  hasMortgage?: boolean;
  mortgageDocument?: File | null;
  hasPowerOfAttorney?: boolean;
  poaDocument?: File | null;
  selectedAgency?: Agency | null;
}

export interface PropertyTransferScreenProps {
  onScreenChange: (screen: PropertyTransferScreens) => void;
  onClose?: () => void;
  formData: PropertyTransferFormData;
  onFormDataChange: (formData: PropertyTransferFormData) => void;
}

export interface Unit {
  id: string;
  salesOrderId: string;
  unitNumber: string;
  propertyName: string;
  isOnHold: boolean;
  city: string;
}

export interface PropertyTransferData {
  selectedUnit?: Unit;
  transferReason?: string;
  documents?: File[];
  status?: 'pending' | 'approved' | 'rejected';
}

export interface PropertyTransferProps {
  onClose: () => void;
  initialScreen?: PropertyTransferScreens;
}

export interface GetAgencyListPayloadType {
  customerId: string;
  referenceId: string;
  search: string;
}
export interface SideDrawerProps {
  isOpen: boolean,
  isLoading?: boolean,
  isCancelLoading?: boolean,
  isCustomInnerContent?: boolean,
  children?: React.ReactNode,
  heroIcon?: string,
  title?: string,
  description?: string,
  drawerInfoWrapCustom?: string,
  infoItemHeading?: string,
  infoItems?: {
    icon: string,
    title: string,
    description: string
  }[],
  drawerPanelCustomClass?: any,
  customStyleOverride?: any,
  actionBtnText?: string,
  cancelBtnText?: string,
  onActionClicked?: () => void,
  onCancelBtnClicked?: () => void,
  onClose: () => void,
}

export interface TimelineProps {
  steps: TimelineStepType[]
}

export interface PropertyTransferBuyer {
  FirstName: string;
  LastName: string;
  PersonEmail: string;
  MobileCountryCode__pc: string;
  MobilePhone__pc: string;
}

export interface PropertyTransferPayload {
  responseKey: string;
  customerId: string;
  orderId: string;
  unitId: string;
  brokerId: string | null;
  payBy: PayByType;
  sellingPrice: string;
  requestType: string;
  srType: string;
  origin: string;
  buyer: PropertyTransferBuyer;
  jointOwners: [];
  comment: string;
  referenceId: string;
  serviceRequestId?: string;
  userSelectedLocation?: string;
}
export interface TransferProperty {
  unitId: string | number;
  gallery?: string[];
  projectName?: string;
  unitName?: string;
  unitType?: string;
  name?: string;
  unitBedrooms?: number | string;
  projectLocation?: string;
  projectCity?: string;
  unitTotalArea?: number | string;
  customerFirstName?: string;
  customerFullName?: string;
  customerId: string;
  serviceRequestId?: string;
}
export interface BuyerCardPropType {
  property: TransferProperty;
}

export interface DirectDebitLocation {
  id: string;
  name: string;
  address: string;
  workingDays: string;
  workingHours: string;
  mapLink: string;
}

export interface TransferDetailsType {
  success: boolean;
  statusMessage: string;
  statusCode: number;
  serviceRequestId?: string;
  statusHistory?: StatusHistoryType[];
  userSelectedLocation: any | null;
  transferFee: any | null;
  stepStatusDetails: any[];
  srStatus: string;
  srDocumentDetails: SRDocumentDetailsType[];
  seller: {
    sellerId: string;
    name: string;
    lastName: string;
    firstName: string;
  };
  payBy: PayByType;
  locationInfo: DirectDebitLocation[];
  buyer: {
    buyerName: string;
    buyerId: string;
  };
  aldarBankDetailsEscrow: {
    swiftCodeEscrow: string;
    ibanNoEscrow: string;
    branchEscrow: string;
    beneficiaryNameEscrow: string;
    bankNameEscrow: string;
    accountNumberEscrow: string;
  };
  aldarBankDetailsCorporate: {
    swiftCodeCorporate: string;
    ibanNoCorporate: string;
    branchCorporate: string;
    beneficiaryNameCorporate: string;
    bankNameCorporate: string;
    accountNumberCorporate: string;
  };
}

export interface UserForHookProps {
  account: {
    Id: string;
    PersonEmail: string;
  };
  token: string;
}

export interface DirectDebitBanksPayloadType {
  customerId: string;
  referenceId: string;
}

export interface BankDetailsPayloadType {
  CustomerIdType: string;
  CustomerBankAccountType: string;
  CustomerBankName: string;
  CustomerIDNumber: string;
  CustomerAccountName: string;
  CustomerIBANNumber: string;
  SalesOrderId: string;
  customerId: string;
  referenceId: string;
}

export interface BuyerBankDetailsProps {
  onMoveToBankingDetails: () => void
  onMoveToDirectDebitFormLocations: () => void;
}

export interface UpdateTransferDetailsPayloadType {
  serviceRequestId: string;
  referenceId: string;
  customerId: string;
  status?: string;
  location?: string;
  pdcCollectionLocation?: string;
  pdcCollectionDate?: string;
  skipStatus?: boolean;
}

export interface MissingStatusUpdateType {
  serviceRequestId: string;
  status: TransferRequestStatuses;
  referenceId: string;
  customerId: string;
}

export interface GetTransferDocPayloadType {
  customerId: string;
  referenceId: string;
  returnURL: string;
  documentId: string;
}

export interface GetPDCOptionsPayloadType {
  serviceRequestId: string;
  referenceId: string;
  customerId: string;
}

export type TimelineStatusConfig = {
  completedSteps?: TimelineSteps[];
  completedSubSteps?: { step: TimelineSteps; subStep: TimelineSubSteps }[];
  inProgressSteps?: TimelineSteps[];
  inProgressSubSteps?: { step: TimelineSteps; subStep: TimelineSubSteps }[];
  disableSellerProceed?: boolean;
  disableBuyerProceed?: boolean;
  disabledBuyerTextKey?: string;
  disabledSellerTextKey?: string;
  sellerNextScreen?: PropertyTransferScreens;
  buyerNextScreen?: PropertyTransferScreens;
};

export interface TimelineSubStepType {
  id: TimelineSubSteps;
  title_en: string;
  title_ar: string;
  status: timelineStepStatuses;
  className?: string;
  iconURL?: string;
}

export interface TimelineStepType {
  id: TimelineSteps;
  step_en: string;
  step_ar: string;
  title_en: string;
  title_ar: string;
  description_en: string;
  description_ar: string;
  status: timelineStepStatuses;
  subSteps: TimelineSubStepType[];
  className?: string;
  iconURL?: string;
}

export interface TimelineActionStatuses {
  disableSellerProceed: boolean;
  disableBuyerProceed: boolean;
  disabledBuyerTextKey?: string;
  disabledSellerTextKey?: string;
}

export interface StatusHistoryType {
  status: TransferRequestStatuses;
  requestType: string;
  createdAt: string;
  customerId: string;
}

export interface BuyerDocumentType {
  title: string;
  docName: string;
  fileSize: string;
  docURL: string;
  document: any;
  isLoading: boolean;
  docsignURL: string;
  isTransferDoc?: boolean;
  signed: boolean;
}

export interface TransferTimelineContent {
  heading: string;
  cardHeading: string;
  proceed: string;
  documentsToBeVerified: string;
  KYCToBeCompleted: string;
  proceedOnceBuyerCompletes: string;
  proceedOnceSellerCompletes: string;
  [key: string]: string;
}